import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { BRAND } from "@/lib/products";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="July 2026">
      <LegalSection>
        <p>
          This Privacy Policy explains how {BRAND.name}, operated by{" "}
          <strong>{BRAND.legalName}</strong> (&ldquo;we&rdquo;,
          &ldquo;us&rdquo;, or &ldquo;our&rdquo;), collects, uses, and protects
          the information you share with us through our website{" "}
          {BRAND.website} and our insurance-related services. By using our
          website or services, you agree to the practices described in this
          policy.
        </p>
      </LegalSection>

      <LegalSection heading="Information We Collect">
        <p>We may collect the following information from you:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Contact details</strong> — name, phone number, email
            address, and city, typically shared when you request a quote or
            call-back.
          </li>
          <li>
            <strong>Insurance requirement details</strong> — the type of cover
            you are interested in (car, health, truck, travel, tractor, etc.)
            and related information needed to help you compare plans.
          </li>
          <li>
            <strong>Usage data</strong> — basic technical information such as
            your browser type, device, and pages visited, collected to keep the
            website secure and to improve our services.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="How We Use Your Information">
        <ul className="list-disc pl-6 space-y-2">
          <li>To understand your insurance requirements and provide quotes.</li>
          <li>
            To contact you regarding your enquiry, policy options, renewals, and
            claim assistance.
          </li>
          <li>
            To share your details with IRDAI-licensed insurers and partners only
            as needed to arrange the cover you request.
          </li>
          <li>To respond to your questions and provide customer support.</li>
          <li>To comply with applicable laws and regulatory requirements.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Sharing of Information">
        <p>
          We do not sell your personal information. We may share your details
          with insurance companies and service partners strictly to process your
          request, or where required by law or a regulatory authority such as
          IRDAI.
        </p>
      </LegalSection>

      <LegalSection heading="Data Security">
        <p>
          We take reasonable technical and organisational measures to protect
          your information against unauthorised access, alteration, or
          disclosure. However, no method of transmission over the internet is
          completely secure, and we cannot guarantee absolute security.
        </p>
      </LegalSection>

      <LegalSection heading="Cookies">
        <p>
          Our website may use cookies and similar technologies to remember your
          preferences and understand how the site is used. You can control or
          disable cookies through your browser settings.
        </p>
      </LegalSection>

      <LegalSection heading="Your Rights">
        <p>
          You may request access to, correction of, or deletion of your personal
          information, or ask us to stop contacting you, by writing to us using
          the details below. We will act on such requests in accordance with
          applicable law.
        </p>
      </LegalSection>

      <LegalSection heading="Contact Us">
        <p>
          For any questions about this Privacy Policy or your data, please
          contact:
        </p>
        <ul className="list-none space-y-1">
          <li>
            <strong>{BRAND.legalName}</strong> ({BRAND.name})
          </li>
          <li>
            Email:{" "}
            <a
              href={`mailto:${BRAND.email}`}
              className="text-[#1e3a8a] hover:underline"
            >
              {BRAND.email}
            </a>
          </li>
          {BRAND.phones.map((p) => (
            <li key={p}>
              Phone:{" "}
              <a
                href={`tel:+91${p}`}
                className="text-[#1e3a8a] hover:underline"
              >
                +91 {p}
              </a>
            </li>
          ))}
        </ul>
      </LegalSection>
    </LegalLayout>
  );
}
